import styled from 'styled-components'

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
`
